export default {
      id: "file-ppt-usage",
      viewBox: "0 0 384 512",
      url: __webpack_public_path__ + "mysource_files/sprite-map.svg#file-ppt",
      toString: function () {
        return this.url;
      }
    }